// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1_CUB","cls2":"Base-cls2_rKg Base-cls1_CUB"};